import Vue from 'vue'
import { GET_TRACKING_PLACES } from '../mutation-types.js'

export const getTrackingPlaces = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('tracking_places')
    .then(
      (response) => {
        dispatch(GET_TRACKING_PLACES, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/trackingPlacesActions.js